export default __webpack_public_path__ + "static/media/chimi_bg.632702b1.png";